export default {
  templates: [],
  template: {},
  items: [],
  querys: {},
  batches: [],
  batch: null
}